import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../api/api';
import { HardHat, Buildings, House, Play } from '@phosphor-icons/react';

const ROLE_STYLE = {
  contractor: { color: '#EA580C', icon: Buildings, label: 'Contractor' },
  worker: { color: '#059669', icon: HardHat, label: 'Worker' },
  homeowner: { color: '#2B4C6F', icon: House, label: 'Homeowner' },
};

const TestAsCard = ({ handleImpersonate }) => {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    adminAPI.getSandboxAccounts()
      .then((r) => setAccounts(r.data.accounts || []))
      .catch(() => setAccounts([]));
  }, []);

  if (accounts.length === 0) return null;

  return (
    <div className="bg-white dark:bg-neutral-800 border-2 border-black dark:border-neutral-700 rounded-xl p-5 shadow-[4px_4px_0px_#000] mt-6" data-testid="test-as-card">
      <div className="flex items-center gap-2 mb-1">
        <Play size={18} weight="fill" className="text-red-600" />
        <h3 className="font-black uppercase tracking-wide text-sm text-neutral-900 dark:text-white">Test The App As...</h3>
      </div>
      <p className="text-xs text-neutral-500 mb-4">
        One click drops you into a sandbox account for that role — use every feature exactly as they would.
        A red banner follows you everywhere with a "Back to Admin" button.
      </p>
      <div className="grid sm:grid-cols-3 gap-3">
        {accounts.map((a) => {
          const s = ROLE_STYLE[a.user_type] || ROLE_STYLE.contractor;
          const Icon = s.icon;
          return (
            <button key={a._id}
              onClick={() => handleImpersonate(a._id, a.name || a.email)}
              className="flex items-center gap-3 p-3 border-2 border-black rounded-lg text-left text-white hover:-translate-y-0.5 transition-transform shadow-[3px_3px_0px_#000]"
              style={{ backgroundColor: s.color }}
              data-testid={`test-as-${a.user_type}`}>
              <Icon size={24} weight="bold" className="shrink-0" />
              <span>
                <span className="block font-black uppercase text-sm">{s.label}</span>
                <span className="block text-[11px] text-white/80">{a.email}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TestAsCard;
